import routerOptions0 from "/home/tickets-r2ncy/tickets.dev2.on24.nl/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}